import React from "react";
import "../dashboard/Dashboard.css";
import moment from "moment";
import Axios from "axios";
import Header from "../header/Header";
import {
  LuCalendarCheck,
  LuCalendarOff,
  LuCheck,
  LuChevronLeft,
  LuChevronRight,
  LuClipboardCheck,
  LuInfo,
  LuLoader2,
  LuLock,
  LuPalmtree,
  LuPencil,
  LuShieldCheck,
} from "react-icons/lu";
import { toast } from "react-toastify";
import { verifyToken } from "../../helpers/signJwtToken";
import { UiButton, TEXTAREA } from "../ui/ui";
import SelectMenu from "../ui/SelectMenu";
import {
  ModalShell,
  WeeklyActualsModal,
  WeeklyPlanModal,
  WeeklyPrioritiesCard,
  fetchWeekActions,
  getWeekRange,
  isFutureWeek,
} from "./WeeklyPriorities";
var config = require("../../config/config");
var queryString = require("query-string");

let momentUiDateFormat = "DD MMMM YYYY";
let startYear = 2014;
let todayDate = new Date();
let thisYear = todayDate.getFullYear() + 2;
let API_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
let API_DATE_FORMAT = "YYYY-MM-DD";
let DATE_START_FORMAT = "YYYY-MM-DD 00:00:00";
let DATE_END_FORMAT = "YYYY-MM-DD 23:59:59";
let blockTime = "11:00am";
let lastTime = "11:59pm";
let yesterday = "";
let previousTwoDays = [];
const ACTUAL_IMPLEMENTED_DATE = new Date("April 01, 2023 23:15:30");
const ABSENT_COLOR = "rgb(218, 104, 104)";
const ACTUALS_PENDING_COLOR = "#da9b68";

const CLOSED_MODAL = {
  show: false,
  startDate: null,
  endDate: null,
  items: [],
  accomplishment: "",
};

class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      month: ("0" + (moment().month() + 1)).slice(-2),
      year: moment().year(),
      calendarData: [],
      cellDetails: {},
      selectedCell: moment().format("YYYY-MM-DD"), // Assuming API_DATE_FORMAT is "YYYY-MM-DD"
      showStatusModal: false,
      status: [],
      userDetails: null,
      requestAdmin: false,
      allCalenderData: [],
      showCodeOfConductModal: false,
      // Weekly priorities keyed by the week's Monday: { status, items, accomplishment }
      weeks: {},
      planModal: CLOSED_MODAL,
      actualsModal: CLOSED_MODAL,
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleCellClick = this.handleCellClick.bind(this);
    this.changeStatusModal = this.changeStatusModal.bind(this);
    this.getAllMarkStatus = this.getAllMarkStatus.bind(this);
    this.getCalenderData = this.getCalenderData.bind(this);
    this.changeCodeOfConductModal = this.changeCodeOfConductModal.bind(this);
    this.editStatus = this.editStatus.bind(this);

    // Popups (code of conduct, status form, weekly prompts) are shown one at
    // a time: each waits until nothing else is open and the previous one has
    // finished its fade-out.
    this.modalQueue = [];
    this.lastModalClosedAt = 0;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.isAnyModalOpen(prevState) && !this.isAnyModalOpen(this.state)) {
      this.lastModalClosedAt = Date.now();
      this.drainModalQueue();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.drainTimer);
  }

  isAnyModalOpen(state = this.state) {
    return (
      state.showCodeOfConductModal ||
      state.showStatusModal ||
      state.planModal.show ||
      state.actualsModal.show
    );
  }

  // Queue a popup; `key` stops the same prompt being queued twice.
  openWhenFree(key, open) {
    if (!this.modalQueue.some((entry) => entry.key === key)) {
      this.modalQueue.push({ key, open });
    }
    this.drainModalQueue();
  }

  drainModalQueue() {
    clearTimeout(this.drainTimer);
    if (this.modalQueue.length === 0 || this.isAnyModalOpen()) return;
    const fadeOutMs = 350;
    const wait = Math.max(0, fadeOutMs - (Date.now() - this.lastModalClosedAt));
    this.drainTimer = setTimeout(() => {
      if (this.modalQueue.length === 0 || this.isAnyModalOpen()) return;
      const { open } = this.modalQueue.shift();
      open();
    }, wait);
  }

  async componentDidMount() {
    const userDetails = await this.getUserDetails();
    this.setState(() => ({
      userDetails: { ...userDetails },
    }));
    this.getAllMarkStatus();
    let weekday = moment().weekday();

    if (weekday !== 0 && weekday !== 6) {
      this.getUserTodayStatus(userDetails);
    }

    this.getCalenderData(userDetails);
    this.loadWeek(this.state.selectedCell, { userId: userDetails?.id });
  }

  async getUserDetails() {
    let userDetails = localStorage.getItem("token");
    if (userDetails) {
      const verifiedToken = await verifyToken(userDetails);
      return verifiedToken?.payload?.sub;
    }
    return null;
  }

  getCalenderData(userDetails) {
    let that = this;
    const tempStartDate = this.state.year + "-" + this.state.month + "-01";
    const endOfMonth = moment(tempStartDate)
      .endOf("month")
      .format(config.API_DATE_FORMAT);
    const startOfMonth = moment(tempStartDate)
      .startOf("month")
      .format(config.API_DATE_FORMAT);

    Axios.post(config.API_BASE + "/user/getUserAttendanceCalender", {
      userId: userDetails ? userDetails.id : that.state.userDetails.id,
      dateBetween: startOfMonth + "|" + endOfMonth,
    })
      .then(function (response) {
        const res = response.data;
        if (!res.status) return;

        const calenderData = res.attendanceData || [];
        const formatCalenderData = {};
        calenderData.forEach((value) => {
          const key = moment(value.calenderDate).format(config.API_DATE_FORMAT);
          formatCalenderData[key] = value;
        });

        that.setState({
          calendarData: formatCalenderData,
          cellDetails: formatCalenderData[that.state.selectedCell] || {},
          allCalenderData: calenderData,
        });
      })
      .catch(function (error) {
        console.log("error", error);
      });
  }

  // Weekly priorities are fetched per week (Mon–Fri) rather than per calendar
  // month, so weeks that span two months (e.g. 29 Sep – 03 Oct) still load.
  loadWeek = async (date, { force = false, userId } = {}) => {
    const uid = userId || this.state.userDetails?.id;
    if (!uid || !date) return null;
    const { startDate, endDate } = getWeekRange(date);
    const existing = this.state.weeks[startDate];
    if (existing && !force && existing.status !== "error") return existing;

    if (!existing || existing.status === "error") {
      this.setState((prev) => ({
        weeks: { ...prev.weeks, [startDate]: { status: "loading", items: [] } },
      }));
    }

    try {
      const { items, accomplishment } = await fetchWeekActions({
        userId: uid,
        startDate,
        endDate,
      });
      const week = { status: "ready", items, accomplishment };
      this.setState((prev) => ({
        weeks: { ...prev.weeks, [startDate]: week },
      }));
      return week;
    } catch (error) {
      console.log("API Error:", error);
      this.setState((prev) => ({
        weeks: { ...prev.weeks, [startDate]: { status: "error", items: [] } },
      }));
      return null;
    }
  };

  getUserTodayStatus(userDetails) {
    let that = this;
    Axios.post(config.API_BASE + "/user/getUserAttendance", {
      userId: userDetails.id,
      attendanceDate: moment().format(config.API_DATE_FORMAT),
    })
      .then(function (response) {
        let res = response.data;
        if (res.status) {
          //After 11 don't show modal
          if (
            typeof res.data !== "undefined" &&
            res.data.length === 0 &&
            moment().isBefore(moment(blockTime, "h:mma"))
          ) {
            that.changeCodeOfConductModal(true);
          }

          if (res.data.length > 0) {
            that.promptWeeklyUpdates();
          }
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  }

  // Prompt for last week's actuals (if any are missing), then for this
  // week's priorities (if none are set) — queued so they never overlap.
  promptWeeklyUpdates = async () => {
    if (this.promptingWeekly) return;
    this.promptingWeekly = true;
    try {
      const userId = this.state.userDetails?.id;
      const lastWeek = moment().subtract(7, "days");
      const previous = await this.loadWeek(lastWeek, { force: true, userId });
      if (
        previous &&
        previous.items.some((item) => !String(item.status || "").trim())
      ) {
        this.openWhenFree("weekly-actuals", () =>
          this.showActualsModal(lastWeek, previous),
        );
      }
      const current = await this.loadWeek(moment(), { force: true, userId });
      if (current && current.items.length === 0) {
        this.openWhenFree("weekly-plan", () =>
          this.showPlanModal(moment(), current),
        );
      }
    } finally {
      this.promptingWeekly = false;
    }
  };

  closeActualsModal = () => {
    this.setState((prev) => ({
      actualsModal: { ...prev.actualsModal, show: false },
    }));
  };

  getAllMarkStatus() {
    let that = this;
    Axios.get(config.API_BASE + "/status/getStatus")
      .then(function (response) {
        let res = response.data;
        that.setState({ status: res.data });
      })
      .catch(function (error) {
        console.log("error", error);
      });
  }

  handleDateChange(year, month) {
    // Keep a day selected so the side panel has something to show:
    // today for the current month, otherwise the 1st.
    const isCurrentMonth =
      Number(year) === moment().year() && Number(month) === moment().month() + 1;
    const selectedCell = isCurrentMonth
      ? moment().format(API_DATE_FORMAT)
      : `${year}-${month}-01`;
    this.setState({ month: month, year: year, selectedCell }, () => {
      this.getCalenderData();
      this.loadWeek(selectedCell);
    });
  }

  handleCellClick(data) {
    this.setState({
      selectedCell: data.cellDate,
      cellDetails: { ...data.cellData },
    });
    this.loadWeek(data.cellDate);
  }

  changeCodeOfConductModal(state) {
    if (state) {
      this.openWhenFree("code-of-conduct", () =>
        this.setState({ showCodeOfConductModal: true }),
      );
    } else {
      this.setState({ showCodeOfConductModal: false });
    }
  }

  changeStatusModal(state, requestAdmin = false) {
    if (state) {
      this.openWhenFree("status", () => this.setState({ showStatusModal: true }));
      return;
    }
    // Prompt for weekly actuals/priorities once the status form is done
    if (this.state.showStatusModal) {
      this.promptWeeklyUpdates();
    }
    this.setState({ showStatusModal: false });
  }

  editStatus(cellDetails) {
    this.setState({ cellDetails }, () => this.changeStatusModal(true, false));
  }

  showPlanModal = (date, week) => {
    const { startDate, endDate } = getWeekRange(date);
    this.setState({
      planModal: {
        show: true,
        startDate,
        endDate,
        items: week ? week.items : [],
        accomplishment: "",
      },
    });
  };

  showActualsModal = (date, week) => {
    const { startDate, endDate } = getWeekRange(date);
    this.setState({
      actualsModal: {
        show: true,
        startDate,
        endDate,
        items: week ? week.items : [],
        accomplishment: week ? week.accomplishment : "",
      },
    });
  };

  // From the weekly card: load the week, then open once nothing else is up
  openPlanModal = async (date) => {
    // Future weeks can't be planned yet (the API rejects them too)
    if (isFutureWeek(getWeekRange(date).startDate)) return;
    const week = await this.loadWeek(date);
    this.openWhenFree("weekly-plan", () => this.showPlanModal(date, week));
  };

  openActualsModal = async (date) => {
    const week = await this.loadWeek(date);
    this.openWhenFree("weekly-actuals", () => this.showActualsModal(date, week));
  };

  render() {
    const selectedDate =
      this.state.selectedCell || moment().format(API_DATE_FORMAT);
    const selectedWeek = getWeekRange(selectedDate);
    const { planModal, actualsModal } = this.state;

    return (
      <>
        <Header />
        <div className="container-fluid dashboardPage">
          <div className="row">
            <div className="col-md-8">
              <Calendar
                ref="cal"
                month={this.state.month}
                year={this.state.year}
                selectedVenues={this.state.selectedVenues}
                calendarData={this.state.calendarData}
                selectedCell={this.state.selectedCell}
                statusList={this.state.status}
                handleDateChange={this.handleDateChange}
                handleCellClick={this.handleCellClick}
              />
            </div>
            <div className="col-md-4">
              <CardDetails
                cellDetails={this.state.cellDetails}
                selectedDate={selectedDate}
                changeCodeOfConductModal={this.changeCodeOfConductModal}
                changeStatusModal={this.changeStatusModal}
                editStatus={this.editStatus}
                allCalenderData={this.state.allCalenderData}
              />
              <WeeklyPrioritiesCard
                startDate={selectedWeek.startDate}
                endDate={selectedWeek.endDate}
                week={this.state.weeks[selectedWeek.startDate]}
                onEditPlan={() => this.openPlanModal(selectedDate)}
                onUpdateActuals={() => this.openActualsModal(selectedDate)}
              />
            </div>
          </div>
          <MarkStatusModal
            {...this.state}
            openModal={this.state.showStatusModal}
            changeStatusModal={this.changeStatusModal}
            getCalenderData={this.getCalenderData}
          />
          <WeeklyActualsModal
            {...actualsModal}
            userId={this.state.userDetails?.id}
            onHide={this.closeActualsModal}
            onSaved={() => this.loadWeek(actualsModal.startDate, { force: true })}
          />
          <WeeklyPlanModal
            {...planModal}
            userId={this.state.userDetails?.id}
            onHide={() =>
              this.setState((prev) => ({
                planModal: { ...prev.planModal, show: false },
              }))
            }
            onSaved={() => this.loadWeek(planModal.startDate, { force: true })}
          />

          <CodeOfConductModal
            {...this.state}
            showCodeOfConductModal={this.state.showCodeOfConductModal}
            changeStatusModal={this.changeStatusModal}
            changeCodeOfConductModal={this.changeCodeOfConductModal}
          />
        </div>
      </>
    );
  }
}

class CardDetails extends React.Component {
  yesterDayCheck(allCalenderData) {
    const datesArray = allCalenderData;
    const today = new Date();
    const weekdays = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let finalDates = [];
    let finalData = [];
    datesArray.forEach((calenderData) => {
      const today = new Date(calenderData.calenderDate);
      const weekdayName = weekdays[today.getDay()];

      if (
        weekdayName === "Sunday" ||
        weekdayName === "Saturday" ||
        (calenderData.holidayName != "" && calenderData.holidayName != null) ||
        calenderData.status == 5 ||
        calenderData.status == 4
      ) {
        return false;
      } else {
        finalDates.push(calenderData.calenderDate);
        finalData.push(calenderData);
      }
    });
    const formatedDate = moment(today).format("YYYY-MM-DD").toString();
    const indexOfDate = finalDates.findIndex((date) => date === formatedDate);
    const previousDay = indexOfDate - 1;
    const secondPreviousDay = indexOfDate - 2;

    previousTwoDays = [finalDates[previousDay], finalDates[secondPreviousDay]];

    previousTwoDays.forEach((dayValue) => {
      if (typeof dayValue === "undefined") {
        const currentDate = moment(todayDate).format("DD");
        if (
          currentDate === "01" ||
          currentDate === "02" ||
          currentDate === "03"
        ) {
          let final = [];
          finalData.forEach((day) => {
            if (day.taskForDay !== "" && day.taskForDay !== null) {
              final.push(day);
            }
          });

          if (final.length > 10) {
            return (previousTwoDays = finalDates.slice(-2));
          }
        }
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    this.yesterDayCheck(nextProps.allCalenderData);
  }
  render() {
    const details = this.props.cellDetails || {};
    let todayDate = moment().format(API_DATE_FORMAT);
    const displayDate = details.calenderDate || this.props.selectedDate;
    let cellDate = moment(displayDate).format(API_DATE_FORMAT);
    const hasRecord =
      typeof details.status !== "undefined" && details.status != null;
    const isWeekend = [0, 6].includes(moment(cellDate).day());
    const canEdit =
      details.attendanceId &&
      moment().isBefore(moment(lastTime, "h:mma")) &&
      todayDate === cellDate;
    const canEnterActuals =
      details.attendanceId &&
      ((moment().isAfter(moment(lastTime, "h:mma")) && todayDate === cellDate) ||
        previousTwoDays.includes(cellDate));
    const showMarkAttendance =
      typeof details.markStatus !== "undefined" &&
      details.markStatus == 0 &&
      todayDate == cellDate &&
      moment().isBefore(moment(blockTime, "h:mma"));
    const showRegularise =
      typeof details.markStatus !== "undefined" &&
      details.markStatus == 0 &&
      todayDate == cellDate &&
      moment().isBetween(moment(blockTime, "h:mma"), moment(lastTime, "h:mma"));

    return (
      <section className="tw-rounded-lg tw-border tw-border-solid tw-border-border/60 tw-bg-card tw-font-sans tw-text-card-foreground tw-shadow-soft">
        <div className="tw-flex tw-items-start tw-justify-between tw-gap-3 tw-p-5 tw-pb-4">
          <div className="tw-min-w-0">
            <div className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-muted-foreground">
              {todayDate === cellDate ? "Today · " : ""}
              {moment(cellDate).format("dddd")}
            </div>
            <h2 className="tw-m-0 tw-mt-0.5 tw-text-xl tw-font-semibold tw-leading-7 tw-text-foreground">
              {moment(cellDate).format(momentUiDateFormat)}
            </h2>
          </div>
          {canEdit && (
            <UiButton
              variant="outline"
              size="sm"
              onClick={this.props.editStatus.bind(this, details)}
            >
              <LuPencil aria-hidden="true" />
              Edit
            </UiButton>
          )}
          {canEnterActuals && (
            <UiButton
              size="sm"
              onClick={this.props.editStatus.bind(this, details)}
            >
              <LuClipboardCheck aria-hidden="true" />
              Enter actuals
            </UiButton>
          )}
        </div>

        <div className="tw-space-y-4 tw-px-5 tw-pb-5">
          {details.holidayName && (
            <div className="tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-bg-amber-50 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-amber-900">
              <LuPalmtree className="tw-shrink-0" aria-hidden="true" />
              Leave: {details.holidayName}
            </div>
          )}

          {hasRecord ? (
            <>
              <DetailRow label="Status">
                <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-bg-secondary tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-foreground">
                  <span
                    className="tw-h-2 tw-w-2 tw-rounded-full"
                    style={{
                      backgroundColor:
                        details.statusColor || "hsl(var(--muted-foreground))",
                    }}
                    aria-hidden="true"
                  />
                  {details.statusName}
                </span>
              </DetailRow>
              <DetailRow label="Planned tasks">
                <TaskLines text={details.taskForDay} empty="No tasks planned" />
              </DetailRow>
              <DetailRow label="Actual tasks">
                <TaskLines text={details.actualTask} empty="Not entered yet" />
              </DetailRow>
              {details.additionalNote && (
                <DetailRow label="Additional notes">
                  <div className="tw-whitespace-pre-line tw-break-words tw-text-sm tw-leading-6 tw-text-foreground">
                    {details.additionalNote}
                  </div>
                </DetailRow>
              )}
            </>
          ) : (
            !details.holidayName && (
              <div className="tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-bg-secondary tw-px-3 tw-py-3 tw-text-sm tw-text-muted-foreground">
                <LuCalendarOff className="tw-shrink-0 tw-text-base" aria-hidden="true" />
                {isWeekend ? "Weekend — no attendance needed" : "No attendance record for this day"}
              </div>
            )
          )}

          {showMarkAttendance && (
            <UiButton
              className="tw-w-full"
              onClick={this.props.changeCodeOfConductModal.bind(this, true)}
            >
              Mark attendance
            </UiButton>
          )}
          {showRegularise && (
            <UiButton
              className="tw-w-full"
              onClick={this.props.changeCodeOfConductModal.bind(this, true, true)}
            >
              Regularise attendance
            </UiButton>
          )}
        </div>
      </section>
    );
  }
}

const DetailRow = ({ label, children }) => (
  <div>
    <div className="tw-mb-1.5 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-muted-foreground">
      {label}
    </div>
    {children}
  </div>
);

const TaskLines = ({ text, empty }) => {
  const lines = String(text || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  if (lines.length === 0) {
    return <div className="tw-text-sm tw-italic tw-text-muted-foreground">{empty}</div>;
  }
  return (
    <ul className="tw-m-0 tw-list-none tw-space-y-1 tw-p-0">
      {lines.map((line, i) => (
        <li key={i} className="tw-flex tw-gap-2 tw-text-sm tw-leading-6 tw-text-foreground">
          <span
            className="tw-mt-2.5 tw-h-1.5 tw-w-1.5 tw-shrink-0 tw-rounded-full tw-bg-primary/60"
            aria-hidden="true"
          />
          <span className="tw-min-w-0 tw-break-words">{line}</span>
        </li>
      ))}
    </ul>
  );
};

class Calendar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      calendarData: this.props.calendarData,
      month: this.props.month,
      year: this.props.year,
    };

    this.handleLeftArrowClick = this.handleLeftArrowClick.bind(this);
    this.handleRightArrowClick = this.handleRightArrowClick.bind(this);
    this.processArrowClick = this.processArrowClick.bind(this);
    this.resetToTodayDate = this.resetToTodayDate.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      calendarData: nextProps.calendarData,
      month: nextProps.month,
      year: nextProps.year,
    });
  }

  componentDidMount() {}

  getCalendarMonthObj(year, month) {
    let monthObj = {};
    let startDate = moment([year, month]);
    let dayOfWeek = startDate.weekday();
    let numberOfDays = startDate.endOf("month").date();
    let date = 1;
    for (let i = 0; i <= 5; i++) {
      monthObj[i] = {};
      for (let j = dayOfWeek; j < 7; j++) {
        if (date == numberOfDays + 1) {
          break;
        }
        monthObj[i][j] = date++;
      }
      dayOfWeek = 0;
    }
    return monthObj;
  }

  handleLeftArrowClick() {
    let newDate = moment([this.state.year, this.state.month - 1]).subtract(
      1,
      "months",
    );
    this.processArrowClick(newDate);
  }

  handleRightArrowClick() {
    let newDate = moment([this.state.year, this.state.month - 1]).add(
      1,
      "months",
    );
    this.processArrowClick(newDate);
  }

  processArrowClick(newDate) {
    this.state.year = newDate.format("YYYY");
    this.state.month = newDate.format("MM");

    if (typeof this.props.handleDateChange !== "undefined") {
      this.props.handleDateChange(this.state.year, this.state.month);
    }
  }

  resetToTodayDate() {
    let month = ("0" + (moment().month() + 1)).slice(-2);
    let year = moment().year();

    let data = {};
    data.day = ("0" + moment().date()).slice(-2);

    this.props.handleDateChange(year, month);

    let calendarData = this.state.calendarData;
    let todayDate = moment().format(config.API_DATE_FORMAT);

    if (typeof this.props.handleCellClick !== "undefined") {
      let data = {
        cellDate: todayDate,
        cellData:
          typeof calendarData[todayDate] !== "undefined"
            ? calendarData[todayDate]
            : {},
      };
      this.props.handleCellClick(data);
    }
  }

  render() {
    let MonthObj = this.getCalendarMonthObj(
      this.props.year,
      this.props.month - 1,
    );
    let calendarData = this.state.calendarData;
    let monthStartDate = this.props.year + "-" + this.props.month + "-01";

    const weeks = [];
    for (let i = 0; i < 6; i++) {
      // The 6th row is only needed for months that spill over
      if (i > 0 && Object.keys(MonthObj[i]).length === 0) continue;
      const cells = [];
      for (let j = 0; j < 7; j++) {
        const day = MonthObj[i][j];
        if (typeof day === "undefined") {
          cells.push(<div key={j} aria-hidden="true" />);
          continue;
        }
        let cellDate =
          this.props.year + "-" + this.props.month + "-" + ("0" + day).slice(-2);
        cells.push(
          <Cell
            {...this.props}
            highLight={this.props.selectedCell == cellDate}
            key={j}
            month={this.props.month}
            year={this.props.year}
            day={day}
            cellDate={cellDate}
            cellData={
              typeof calendarData[cellDate] !== "undefined"
                ? calendarData[cellDate]
                : {}
            }
            handleCellClick={this.props.handleCellClick}
          />,
        );
      }
      weeks.push(cells);
    }

    const legend = [
      ...(this.props.statusList || [])
        .filter((s) => s.statusColor && s.statusName)
        .map((s) => ({ label: s.statusName, color: s.statusColor })),
      { label: "Absent", color: ABSENT_COLOR },
      { label: "Actuals pending", color: ACTUALS_PENDING_COLOR },
    ];

    return (
      <section className="tw-rounded-lg tw-border tw-border-solid tw-border-border/60 tw-bg-card tw-p-4 tw-font-sans tw-text-card-foreground tw-shadow-soft sm:tw-p-6">
        <div className="tw-mb-5 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
          <h2 className="tw-m-0 tw-text-xl tw-font-semibold tw-leading-7 tw-text-foreground">
            {moment(monthStartDate).format("MMMM")} {this.state.year}
          </h2>
          <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
            <MonthFilter
              month={this.state.month}
              year={this.state.year}
              handleDateChange={this.props.handleDateChange}
            />
            <div className="tw-flex tw-items-center tw-gap-1">
              <UiButton
                variant="outline"
                size="icon"
                aria-label="Previous month"
                onClick={this.handleLeftArrowClick}
              >
                <LuChevronLeft aria-hidden="true" />
              </UiButton>
              <UiButton
                variant="outline"
                size="icon"
                aria-label="Next month"
                onClick={this.handleRightArrowClick}
              >
                <LuChevronRight aria-hidden="true" />
              </UiButton>
            </div>
            <UiButton variant="outline" size="sm" onClick={this.resetToTodayDate}>
              Today
            </UiButton>
          </div>
        </div>

        <div className="tw-mb-2 tw-grid tw-grid-cols-7 tw-gap-1 sm:tw-gap-1.5">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
            <div
              key={d}
              className="tw-text-center tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-muted-foreground"
            >
              {d}
            </div>
          ))}
        </div>
        <div className="tw-grid tw-grid-cols-7 tw-gap-1 sm:tw-gap-1.5">
          {weeks.map((cells, i) => (
            <React.Fragment key={i}>{cells}</React.Fragment>
          ))}
        </div>

        <div className="tw-mt-5 tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-2 tw-border-0 tw-border-t tw-border-solid tw-border-border tw-pt-4">
          {legend.map((item) => (
            <span
              key={item.label}
              className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-xs tw-text-muted-foreground"
            >
              <span
                className="tw-h-2.5 tw-w-2.5 tw-rounded-sm"
                style={{ backgroundColor: item.color }}
                aria-hidden="true"
              />
              {item.label}
            </span>
          ))}
        </div>
      </section>
    );
  }
}

class Cell extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      year: this.props.year,
      month: this.props.month,
    };

    this.toggleDetailsModal = this.toggleDetailsModal.bind(this);
    this.handleCellClick = this.handleCellClick.bind(this);
  }

  toggleDetailsModal(toggle) {
    this.setState({ detailsModal: toggle });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      year: nextProps.year,
      month: nextProps.month,
    });
  }

  handleCellClick(cellDate) {
    if (typeof this.props.day === "undefined") {
      return false;
    }

    if (typeof this.props.handleCellClick !== "undefined") {
      let data = {
        cellDate:
          this.state.year +
          "-" +
          this.state.month +
          "-" +
          ("0" + this.props.day).slice(-2),
        cellData: this.props.cellData,
      };
      this.props.handleCellClick(data);
    }
  }

  render() {
    let cellDate =
      this.state.year +
      "-" +
      this.state.month +
      "-" +
      ("0" + this.props.day).slice(-2);
    let cellData =
      typeof this.props.cellData !== "undefined" ? this.props.cellData : {};
    let momentDateWeek = moment(cellDate).format("dddd");
    let isActualTaskSubmitted =
      typeof this.props.cellData.actualTask !== "undefined" &&
      this.props.cellData.actualTask != null &&
      this.props.cellData.actualTask != "";
    let isWeekEnd =
      momentDateWeek === "Sunday" || momentDateWeek === "Saturday";
    let isHoliday =
      typeof cellData.holidayName !== "undefined" &&
      cellData.holidayName != null &&
      cellData.holidayName != "";
    let statusColor = cellData.statusColor;
    let statusShortName = cellData.shortName;

    if (moment().diff(cellDate) > 0) {
      statusColor =
        cellData.markStatus == 0
          ? ABSENT_COLOR
          : !isActualTaskSubmitted &&
              cellData.calenderDate >=
                moment(ACTUAL_IMPLEMENTED_DATE).format("YYYY-MM-DD") &&
              !isHoliday &&
              ![4, 5].includes(cellData.status)
            ? ACTUALS_PENDING_COLOR
            : cellData.statusColor;
      statusShortName =
        cellData.markStatus == 0 && cellData.status != 6
          ? "A"
          : cellData.shortName;
    }

    const fill = !isWeekEnd && statusColor ? statusColor : null;
    const label = isHoliday ? "L" : isWeekEnd ? "" : statusShortName;
    const isToday = cellDate === moment().format(API_DATE_FORMAT);

    return (
      <button
        type="button"
        data-date={cellDate}
        onClick={this.handleCellClick.bind(this, cellDate)}
        aria-pressed={this.props.highLight}
        aria-label={moment(cellDate).format("dddd, D MMMM YYYY")}
        className={`tw-flex tw-h-14 tw-w-full tw-flex-col tw-justify-between tw-rounded-md tw-p-1.5 tw-text-left tw-text-foreground tw-transition-shadow focus-visible:tw-outline-none sm:tw-h-20 sm:tw-p-2 ${
          fill
            ? "tw-border-0"
            : isWeekEnd
              ? "tw-border-0 tw-bg-secondary/70 tw-text-muted-foreground"
              : "tw-border tw-border-solid tw-border-border tw-bg-white"
        } ${
          this.props.highLight
            ? "tw-ring-2 tw-ring-primary tw-ring-offset-2"
            : "hover:tw-ring-2 hover:tw-ring-primary/30 focus-visible:tw-ring-2 focus-visible:tw-ring-primary/50"
        }`}
        style={fill ? { backgroundColor: fill } : undefined}
      >
        <span
          className={`tw-ml-auto tw-flex tw-h-6 tw-min-w-[24px] tw-items-center tw-justify-center tw-rounded-full tw-px-1 tw-text-xs tw-font-semibold sm:tw-text-sm ${
            isToday ? "tw-bg-primary tw-text-primary-foreground" : ""
          }`}
        >
          {this.props.day}
        </span>
        <span className="tw-hidden tw-text-xs tw-font-bold tw-tracking-wide sm:tw-block">
          {label}
        </span>
      </button>
    );
  }
}

class MonthFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      year: this.props.year,
      month: this.props.month,
    };

    this.handleDateChange = this.handleDateChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      year: nextProps.year,
      month: nextProps.month,
    });
  }

  handleMonthChange(event) {
    this.setState({ month: event.target.value }, function () {
      this.handleDateChange();
    });
  }

  handleYearChange(event) {
    this.setState({ year: event.target.value }, function () {
      this.handleDateChange();
    });
  }

  handleDateChange() {
    this.props.handleDateChange(this.state.year, this.state.month);
  }

  render() {
    const years = [];
    for (let y = startYear + 1; y <= thisYear + 1; y++) years.push(y);
    const months = moment.monthsShort();

    return (
      <div className="tw-flex tw-items-center tw-gap-1.5">
        <SelectMenu
          size="sm"
          ariaLabel="Month"
          className="tw-w-[92px]"
          fullWidth
          menuWidth={140}
          value={this.state.month}
          onChange={(value) => this.handleMonthChange({ target: { value } })}
          options={months.map((name, i) => ({
            value: ("0" + (i + 1)).slice(-2),
            label: name,
          }))}
        />
        <SelectMenu
          size="sm"
          ariaLabel="Year"
          className="tw-w-[92px]"
          fullWidth
          menuWidth={120}
          value={String(this.state.year)}
          onChange={(value) => this.handleYearChange({ target: { value } })}
          options={years.map((y) => ({ value: String(y), label: String(y) }))}
        />
      </div>
    );
  }
}

class MarkStatusModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      details: {
        userId: null,
        attendanceDate: moment(this.props.cellDetails.calenderDate).format(
          API_DATE_FORMAT,
        ),
        taskForDay: "",
        status: 0,
        additionalNote: "",
        missedReason: "",
        actualTask: "",
      },
      btnDisable: false,
      leaveBalance: {
        plBalance: 0,
        chBalance: 0,
      },
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.isValid = this.isValid.bind(this);
    this.submitDetails = this.submitDetails.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.submitDetailsAdmin = this.submitDetailsAdmin.bind(this);
    this.resetData = this.resetData.bind(this);
    this.getUserLeaves = this.getUserLeaves.bind(this);
    this.updateDetails = this.updateDetails.bind(this);
  }

  async getUserDetails() {
    let userDetails = localStorage.getItem("token");
    if (userDetails) {
      const verifiedToken = await verifyToken(userDetails);
      return verifiedToken?.payload?.sub;
    }
    return null;
  }

  componentWillReceiveProps(nextProps) {
    let propCellDetails = nextProps.cellDetails;
    let details = this.state.details;
    details.attendanceDate = moment(nextProps.cellDetails.calenderDate).format(
      API_DATE_FORMAT,
    );
    details.status = propCellDetails.status;
    details.taskForDay = propCellDetails.taskForDay;
    details.actualTask = propCellDetails.actualTask
      ? propCellDetails.actualTask
      : propCellDetails.taskForDay;
    details.missedReason = propCellDetails.missedReason;
    details.additionalNote = propCellDetails.additionalNote;
    details.attendanceId =
      typeof propCellDetails.attendanceId !== "undefined"
        ? propCellDetails.attendanceId
        : null;
    details.userId = nextProps.userDetails.id;
    this.setState({
      show: nextProps.openModal,
      details: details,
    });
  }

  async componentDidMount() {
    const userDetails = await this.getUserDetails();
    this.setState((prevdetails) => ({
      details: { ...prevdetails.details, userId: userDetails.id },
    }));
  }

  getUserLeaves() {
    let that = this;
    Axios.get(
      config.API_BASE +
        "/leave/getUserLeaves?" +
        queryString.stringify({
          userId: this.props.userDetails.id,
        }),
    )
      .then(function (response) {
        let res = response.data;
        if (
          res.status &&
          typeof res.data !== "undefined" &&
          res.data.length > 0
        ) {
          let leaveObject = res.data[0];

          that.setState({ leaveBalance: leaveObject });
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  }

  isValid() {
    let isValid = true;

    let details = this.state.details;
    let mendatoryFields = ["userId", "attendanceDate", "taskForDay", "status"];
    if (this.props.requestAdmin) {
      mendatoryFields.push("missedReason");
    }
    if (this.state.details.attendanceId) {
      mendatoryFields.push("attendanceId");
    }
    mendatoryFields.map(function (value, index) {
      if (
        typeof details[value] === "undefined" ||
        details[value] === "" ||
        details[value] == null
      ) {
        isValid = false;
        //exit from loop
        return false;
      }
    });
    if (typeof details.status === "undefined" || details.status == 0) {
      return false;
    }

    return isValid;
  }

  onSubmit() {
    // if (this.props.requestAdmin) {
    //   this.submitDetailsAdmin();
    // } else {
    //   this.submitDetails();
    // }
    if (this.state.details.attendanceId) {
      this.updateDetails();
    } else {
      this.submitDetails();
    }
  }

  submitDetailsAdmin() {
    if (!this.isValid()) {
      toast.error("Please fill in all required fields");
      return false;
    }

    this.setState({ btnDisable: true }, function () {
      let that = this;
      let axiosData = {
        userId: this.props.userDetails.id,
        date: moment(this.state.details.attendanceDate).format(API_DATE_FORMAT),
        attendanceStatus: this.state.details.status,
        status: 0,
        task: this.state.details.taskForDay,
        additionalNotes: this.state.details.additionalNote,
      };

      Axios.post(
        config.API_BASE + "/attendance/insertAttendanceRequest",
        axiosData,
      )
        .then(function (response) {
          let res = response.data;
          if (res.status) {
            toast.success("Request sent to admin");
            if (typeof that.props.getCalenderData !== "undefined") {
              that.props.getCalenderData(that.props.userDetails);
            }
            that.resetData();
            that.handleClose();
          } else {
            toast.error(res.msg);
          }
          that.setState({ btnDisable: false });
        })
        .catch(function (error) {
          that.setState({ btnDisable: false });
          console.log("error", error);
        });
    });
  }

  resetData() {
    let details = this.state.details;
    details.taskForDay = "";
    details.status = 0;
    details.additionalNote = "";

    this.setState({ details: details });
  }

  updateDetails() {
    let todayDate = moment().format(API_DATE_FORMAT);
    let cellDate = moment(this.props.cellDetails.calenderDate).format(
      API_DATE_FORMAT,
    );
    if (!this.isValid()) {
      toast.error("Please fill in all required fields");
      return false;
    }

    this.setState({ btnDisable: true }, function () {
      let that = this;
      let axiosData = {
        attendanceId: this.state.details.attendanceId,
        userId: this.props.userDetails.id,
        date: moment(this.state.details.attendanceDate).format(API_DATE_FORMAT),
        attendanceStatus: this.state.details.status,
        status: 0,
        task: this.state.details.taskForDay,
        actualTask: this.state.details.actualTask,
        additionalNotes: this.state.details.additionalNote,
      };
      if (
        moment().isBefore(moment(lastTime, "h:mma")) &&
        cellDate == todayDate
      ) {
        axiosData.actualTask = "";
      }
      Axios.post(
        config.API_BASE + "/attendance/updateAttendaceDetails",
        axiosData,
      )
        .then(function (response) {
          let res = response.data;
          if (res.status) {
            toast.success("Attendance updated");
            if (typeof that.props.getCalenderData !== "undefined") {
              that.props.getCalenderData(that.props.userDetails);
            }
            that.resetData();
            that.handleClose();
          } else {
            toast.error(res.msg);
          }
          that.setState({ btnDisable: false });
        })
        .catch(function (error) {
          that.setState({ btnDisable: false });
        });
    });
  }

  submitDetails() {
    if (!this.isValid()) {
      toast.error("Please fill in all required fields");
      return false;
    }
    switch (this.state.details.status) {
      case "5":
        if (this.state.leaveBalance.plBalance <= 0) {
          toast.error("Not enough Paid Leave balance");
          return false;
        }
        break;
      case "7":
        if (this.state.leaveBalance.chBalance <= 0) {
          toast.error("Not enough Optional Leave balance");
          return false;
        }
        break;
    }
    let that = this;
    this.setState({ btnDisable: true }, function () {
      Axios.post(config.API_BASE + "/user/insertUserStatus", this.state.details)
        .then(function (response) {
          let res = response.data;
          if (res.status) {
            toast.success("Attendance marked");
            if (typeof that.props.getCalenderData !== "undefined") {
              that.props.getCalenderData(that.props.userDetails);
            }
            that.resetData();
            that.handleClose();
            //Open CEO Dashboard
            window.open("https://conversation.greatmanager.app/home", "_blank");
          } else if (typeof res.msg !== "undefined") {
            toast.error(res.msg);
          } else {
            toast.error("Something went wrong. Please try again.");
          }
          that.setState({ btnDisable: false });
        })
        .catch(function (error) {
          console.log("error", error);
          toast.error("Something went wrong. Please try again.");
          that.setState({ btnDisable: false });
        });
    });
  }

  handleClose() {
    this.setState({ show: false }, function () {
      this.props.changeStatusModal(false);
    });
  }

  handleChange(state, evt) {
    let details = this.state.details;
    details[state] = evt.target.value;

    if (state == "status" && (evt.target.value == 5 || evt.target.value == 7)) {
      this.getUserLeaves();
    }
    this.setState({ details: details });
  }

  render() {
    let todayDate = moment().format(API_DATE_FORMAT);
    let cellDate = moment(this.props.cellDetails.calenderDate).format(
      API_DATE_FORMAT,
    );
    let details = this.state.details;
    let isOptionalHoliday =
      typeof this.props.cellDetails.optionalHolidayName !== "undefined" &&
      this.props.cellDetails.optionalHolidayName != null &&
      this.props.cellDetails.optionalHolidayName != "";
    // After the day closes (or for the two previous working days) only the
    // actual task can be entered; status and plan are locked.
    const actualsMode =
      (moment().isAfter(moment(lastTime, "h:mma")) && todayDate === cellDate) ||
      previousTwoDays.includes(cellDate);
    const showMissedReason =
      this.props.requestAdmin && moment().isAfter(moment(blockTime, "h:mma"));
    const statusOptions = (this.props.status || []).filter(
      (value) =>
        !(
          (!isOptionalHoliday && value.id == config.OPTIONAL_HOLIDAY) ||
          value.id == config.WORK_WITHOUT_PAY
        ),
    );
    const leaveBalanceValue =
      details.status == config.OPTIONAL_HOLIDAY
        ? this.state.leaveBalance.chBalance
        : this.state.leaveBalance.plBalance;
    const title = actualsMode
      ? "Enter your actuals"
      : details.attendanceId
        ? "Update your status"
        : "Mark your status";
    const submitLabel = actualsMode
      ? "Save actuals"
      : details.attendanceId
        ? "Update details"
        : "Submit";

    return (
      <ModalShell
        show={this.state.show}
        onHide={this.handleClose}
        busy={this.state.btnDisable}
        icon={actualsMode ? LuClipboardCheck : LuCalendarCheck}
        title={title}
        subtitle={moment(details.attendanceDate).format("dddd, DD MMMM YYYY")}
        footer={
          <>
            <div className="tw-text-xs tw-text-muted-foreground">
              <span className="tw-text-destructive">*</span> Required
            </div>
            <div className="tw-flex tw-gap-2">
              <UiButton
                variant="outline"
                onClick={this.handleClose}
                disabled={this.state.btnDisable}
              >
                Cancel
              </UiButton>
              <UiButton onClick={this.onSubmit} disabled={this.state.btnDisable}>
                {this.state.btnDisable ? (
                  <LuLoader2 className="tw-animate-spin" aria-hidden="true" />
                ) : (
                  <LuCheck aria-hidden="true" />
                )}
                {submitLabel}
              </UiButton>
            </div>
          </>
        }
      >
        <div className="tw-space-y-5">
          {actualsMode && (
            <div className="tw-flex tw-items-start tw-gap-2 tw-rounded-md tw-bg-secondary tw-px-3 tw-py-2.5 tw-text-sm tw-text-muted-foreground">
              <LuLock className="tw-mt-0.5 tw-shrink-0" aria-hidden="true" />
              Status and planned tasks are locked for this day. Add what you
              actually worked on.
            </div>
          )}

          <div>
            <ModalFieldLabel required>Status</ModalFieldLabel>
            <div
              className="tw-grid tw-grid-cols-2 tw-gap-2 sm:tw-grid-cols-3"
              role="radiogroup"
              aria-label="Status"
            >
              {statusOptions.map((value) => {
                const selected = details.status == value.id;
                return (
                  <button
                    key={value.id}
                    type="button"
                    role="radio"
                    aria-checked={selected}
                    disabled={actualsMode}
                    onClick={() =>
                      this.handleChange("status", {
                        target: { value: String(value.id) },
                      })
                    }
                    className={`tw-flex tw-min-h-[40px] tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-solid tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-font-medium tw-transition-colors disabled:tw-cursor-not-allowed ${
                      selected
                        ? "tw-border-primary tw-bg-primary/5 tw-text-foreground tw-ring-1 tw-ring-primary"
                        : "tw-border-border tw-bg-white tw-text-foreground hover:tw-bg-secondary disabled:tw-opacity-50"
                    }`}
                  >
                    <span
                      className="tw-h-2.5 tw-w-2.5 tw-shrink-0 tw-rounded-full"
                      style={{ backgroundColor: value.statusColor || "#cbd5e1" }}
                      aria-hidden="true"
                    />
                    <span className="tw-min-w-0 tw-flex-1 tw-leading-5">
                      {value.statusName}
                    </span>
                    {selected && (
                      <LuCheck className="tw-shrink-0 tw-text-primary" aria-hidden="true" />
                    )}
                  </button>
                );
              })}
            </div>
            {(details.status == config.EARNED_LEAVE ||
              details.status == config.OPTIONAL_HOLIDAY) && (
              <div className="tw-mt-2 tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-text-muted-foreground">
                <LuInfo aria-hidden="true" />
                {details.status == config.OPTIONAL_HOLIDAY
                  ? "Optional leave"
                  : "Paid leave"}{" "}
                balance:
                <span className="tw-font-semibold tw-text-foreground">
                  {leaveBalanceValue}
                </span>
              </div>
            )}
          </div>

          <div>
            <ModalFieldLabel htmlFor="taskForDay" required>
              Tasks for the day
            </ModalFieldLabel>
            <textarea
              id="taskForDay"
              rows={4}
              className={`${TEXTAREA} disabled:tw-cursor-not-allowed disabled:tw-bg-secondary disabled:tw-text-muted-foreground`}
              placeholder={"One task per line, e.g.\nQ3 task allocations\nBug tracker review"}
              disabled={actualsMode}
              value={details.taskForDay || ""}
              onChange={this.handleChange.bind(this, "taskForDay")}
            />
          </div>

          {actualsMode && (
            <div>
              <ModalFieldLabel htmlFor="actualTask" required>
                What you actually did
              </ModalFieldLabel>
              <textarea
                id="actualTask"
                rows={4}
                className={TEXTAREA}
                placeholder="One task per line"
                value={details.actualTask || ""}
                onChange={this.handleChange.bind(this, "actualTask")}
              />
            </div>
          )}

          {showMissedReason && (
            <div>
              <ModalFieldLabel htmlFor="missedReason" required>
                Why did you miss marking your attendance?
              </ModalFieldLabel>
              <textarea
                id="missedReason"
                rows={3}
                className={TEXTAREA}
                value={details.missedReason || ""}
                onChange={this.handleChange.bind(this, "missedReason")}
              />
            </div>
          )}

          <div>
            <ModalFieldLabel htmlFor="additionalNote">
              Additional notes
            </ModalFieldLabel>
            <textarea
              id="additionalNote"
              rows={3}
              className={TEXTAREA}
              placeholder="Anything else your manager should know"
              value={details.additionalNote || ""}
              onChange={this.handleChange.bind(this, "additionalNote")}
            />
          </div>
        </div>
      </ModalShell>
    );
  }
}

const ModalFieldLabel = ({ htmlFor, required = false, children }) => (
  <label
    htmlFor={htmlFor}
    className="tw-m-0 tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground"
  >
    {children}
    {required && <span className="tw-ml-0.5 tw-text-destructive">*</span>}
  </label>
);

class CodeOfConductModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      selectedContent: "",
      userDetails: null,
      buttonDisabled: false,
      remainingSeconds: 15,
      submitting: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.showCodeOfConductModal &&
      !prevProps.showCodeOfConductModal
    ) {
      this.setState(
        {
          modalIsOpen: this.props.showCodeOfConductModal,
          userDetails: this.props.userDetails,
        },
        () => {
          this.startTimer();
        },
      );
    } else if (
      !this.props.showCodeOfConductModal &&
      prevProps.showCodeOfConductModal
    ) {
      this.setState({ modalIsOpen: false });
      this.stopTimer();
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  startTimer = () => {
    this.stopTimer(); // Ensure any existing timer is cleared
    this.setState({ buttonDisabled: true, remainingSeconds: 15 });

    this.timerInterval = setInterval(() => {
      const { remainingSeconds } = this.state;
      if (remainingSeconds > 0) {
        this.setState({ remainingSeconds: remainingSeconds - 1 });
      } else {
        this.stopTimer();
        this.setState({ buttonDisabled: false, remainingSeconds: 15 });
      }
    }, 1000);
  };

  stopTimer = () => {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  };
  async getUserDetails() {
    let userDetails = localStorage.getItem("token");
    if (userDetails) {
      const verifiedToken = await verifyToken(userDetails);
      return verifiedToken?.payload?.sub;
    }
    return null;
  }
  async componentDidMount() {
    const userDetails = await this.getUserDetails();
    this.setState(() => ({
      userDetails: { ...userDetails },
    }));
    this.getPopupContent();
  }

  getPopupContent = () => {
    Axios.get(config.API_BASE + "/popup/getPopupContent")
      .then((response) => {
        const res = response.data;
        const contents = res.data; // Assuming the data fetched is an array of contents

        // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        const dayOfWeek = new Date().getDay();

        // Map the day of the week to the appropriate popupId
        const popupIdMap = {
          0: 1,
          1: 1, // Monday
          2: 2, // Tuesday
          3: 3, // Wednesday
          4: 4, // Thursday
          5: 5, // Friday
          6: 5,
        };
        // Get the popupId based on the current day of the week
        const selectedPopupId = popupIdMap[dayOfWeek];

        // Find the content based on the selectedPopupId from the fetched data
        const selectedContent = contents.find(
          (content) => content.popupId === selectedPopupId,
        );

        // Update state with the selected content
        this.setState({ selectedContent });
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
    this.stopTimer();
    // Tell the dashboard too, otherwise "Mark attendance" can't reopen it
    this.props.changeCodeOfConductModal(false);
  };

  storeUserInteraction(status) {
    const { selectedContent } = this.state;
    this.setState({ submitting: true });

    // Make an Axios POST request to store user's interaction
    Axios.post(config.API_BASE + "/popup/storeUserPopupInteraction", {
      userId: this.state.userDetails.id, // Use the userId from the component's state
      popupId: selectedContent.popupId, // Use popupId from the fetched popup content
      status,
    })
      .then((response) => {
        this.closeModal();
        this.props.changeCodeOfConductModal(false);
        this.props.changeStatusModal(true);
      })
      .catch((error) => {
        console.error("Error storing interaction:", error);
        toast.error("Something went wrong. Please try again.");
      })
      .finally(() => this.setState({ submitting: false }));
  }

  handleButton = (status) => {
    this.storeUserInteraction(status);
  };

  render() {
    const { selectedContent, buttonDisabled, remainingSeconds, submitting } =
      this.state;
    const contentArray = selectedContent?.description
      ? selectedContent.description
          .split("\n")
          // The stored text is already numbered ("1. ...", "a) ..."); drop
          // that so it doesn't repeat the number badges shown here.
          .map((line) =>
            line
              .trim()
              .replace(/^\d+\s*[.)\-:]\s*/, "")
              .replace(/^[a-z][.)]\s+/i, ""),
          )
          .filter(Boolean)
      : [];
    // Lines ending with ":" introduce the list ("For example:"), so they're
    // shown as plain text rather than as a numbered point.
    let pointNumber = 0;
    const contentItems = contentArray.map((line) => {
      const isIntro = line.endsWith(":");
      return { line, isIntro, n: isIntro ? null : ++pointNumber };
    });
    const waitedPct = Math.round(((15 - remainingSeconds) / 15) * 100);

    return (
      <ModalShell
        show={this.state.modalIsOpen}
        onHide={this.closeModal}
        busy={submitting}
        icon={LuShieldCheck}
        title={selectedContent?.title || "Code of conduct"}
        subtitle="Please read this before marking your attendance."
        footer={
          <>
            <div className="tw-flex tw-min-w-[160px] tw-flex-1 tw-items-center tw-gap-3 sm:tw-max-w-[260px]">
              {buttonDisabled ? (
                <>
                  <div className="tw-h-1.5 tw-flex-1 tw-overflow-hidden tw-rounded-full tw-bg-secondary">
                    <div
                      className="tw-h-full tw-rounded-full tw-bg-gradient-primary tw-transition-all tw-duration-1000 tw-ease-linear"
                      style={{ width: `${waitedPct}%` }}
                    />
                  </div>
                  <span className="tw-whitespace-nowrap tw-text-xs tw-text-muted-foreground">
                    Accept in{" "}
                    <span className="tw-font-semibold tw-tabular-nums tw-text-foreground">
                      {remainingSeconds}s
                    </span>
                  </span>
                </>
              ) : (
                <span className="tw-text-xs tw-text-muted-foreground">
                  Thanks for reading.
                </span>
              )}
            </div>
            <div className="tw-flex tw-gap-2">
              <UiButton
                variant="outline"
                onClick={() => this.handleButton(false)}
                disabled={buttonDisabled || submitting}
              >
                Decline
              </UiButton>
              <UiButton
                onClick={() => this.handleButton(true)}
                disabled={buttonDisabled || submitting}
              >
                {submitting ? (
                  <LuLoader2 className="tw-animate-spin" aria-hidden="true" />
                ) : (
                  <LuCheck aria-hidden="true" />
                )}
                {buttonDisabled ? `Accept (${remainingSeconds}s)` : "Accept"}
              </UiButton>
            </div>
          </>
        }
      >
        {contentArray.length === 0 ? (
          <div className="tw-space-y-2" aria-busy="true">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="tw-h-10 tw-animate-pulse tw-rounded-md tw-bg-secondary"
              />
            ))}
          </div>
        ) : (
          <ol className="tw-m-0 tw-list-none tw-space-y-2 tw-p-0">
            {contentItems.map(({ line, isIntro, n }, index) =>
              isIntro ? (
                <li
                  key={index}
                  className="tw-px-1 tw-pb-1 tw-text-sm tw-font-medium tw-leading-6 tw-text-foreground"
                >
                  {line}
                </li>
              ) : (
                <li
                  key={index}
                  className="tw-flex tw-gap-3 tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-white tw-p-3"
                >
                  <span className="tw-mt-0.5 tw-flex tw-h-6 tw-w-6 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary/10 tw-text-xs tw-font-semibold tw-text-primary">
                    {n}
                  </span>
                  <span className="tw-min-w-0 tw-break-words tw-text-sm tw-leading-6 tw-text-foreground">
                    {line}
                  </span>
                </li>
              ),
            )}
          </ol>
        )}
      </ModalShell>
    );
  }
}

export default Dashboard;
